import type { Environment } from '@openeducation/oe-it-services';

import TeacherProfileDao from './dao/teacher-profile.dao';

export abstract class TeacherProfileService {
  static async changePassword(
    env: Environment,
    currentPassword: string,
    password: string,
    accountName?: string,
    teacherId?: number
  ) {
    if (!accountName) {
      return Promise.reject(new Error('Missing accountName'));
    }
    if (!teacherId) {
      return Promise.reject(new Error('Missing teacherId'));
    }
    return TeacherProfileDao.changePassword(
      env,
      currentPassword,
      password,
      accountName,
      teacherId
    );
  }
}
